import { Gift, Wallet, Network, Search, CheckCircle2, Mail, Send } from "lucide-react";
import { Layout } from "./LegalPage";
import { getLang } from "../i18n";

const CONTRACT = "0x47935d80e63eddf23f351db33b2363b6925f1530";

const copy = {
  it: {
    title: "Ottieni Gratis",
    updated: "USTP · Distribuzione gratuita",
    hero: 'Ricevi gratis 1,5 Mln di USTP + il file MP3, versione cine/pop di "Universe", per ascolto personale.',
    howTo: "Ecco come fare",
    teamLabel: "Il Team",
    teamName: "USTP — Project",
    supportTitle: "Hai bisogno di assistenza?",
    supportText: "Contattaci:",
    steps: [
      { icon: Wallet, text: "Apri il tuo wallet (es. MetaMask o altro wallet)." },
      { icon: Network, text: "Setta il tuo wallet sulla rete Polygon." },
      {
        icon: Search,
        text: "Importa il Token USTP nella tua lista: vai nella sezione Token e cerca lo smart contract USTP incollando nella barra di ricerca il codice contratto:",
        contract: true,
      },
      { icon: CheckCircle2, text: "Aggiungi USTP alla tua lista Token, ovvero dai conferma dell'importazione." },
      { icon: Mail, text: "Copia il codice di ricezione (il tuo indirizzo wallet) ed inviacelo a:", mail: "info@ustp.it" },
      { icon: Send, text: "Riceverai entro 24 ore i token USTP al tuo wallet e il file MP3 direttamente nella tua casella email." },
    ],
  },
  en: {
    title: "Get Free",
    updated: "USTP · Free distribution",
    hero: 'Receive 1.5 million USTP for free + the MP3 file, cine/pop version of "Universe", for personal listening.',
    howTo: "Here's how to do it",
    teamLabel: "The Team",
    teamName: "USTP — Project",
    supportTitle: "Need assistance?",
    supportText: "Contact us:",
    steps: [
      { icon: Wallet, text: "Open your wallet (e.g. MetaMask or another wallet)." },
      { icon: Network, text: "Set your wallet to the Polygon network." },
      {
        icon: Search,
        text: "Import the USTP token into your list: go to the Token section and search for the USTP smart contract by pasting the contract code into the search bar:",
        contract: true,
      },
      { icon: CheckCircle2, text: "Add USTP to your token list, i.e. confirm the import." },
      { icon: Mail, text: "Copy your receiving code (your wallet address) and send it to us at:", mail: "info@ustp.it" },
      { icon: Send, text: "Within 24 hours you will receive the USTP tokens in your wallet and the MP3 file directly in your email inbox." },
    ],
  },
};

export default function OttieniGratisPage() {
  const c = copy[getLang()] || copy.it;
  return (
    <Layout title={c.title} updated={c.updated}>
      <div data-testid="ottieni-gratis-content" className="space-y-8">
        <div className="flex items-start gap-4 rounded-3xl border border-sky-200 bg-gradient-to-br from-sky-600 to-sky-800 p-6 sm:p-8 text-white">
          <Gift size={28} className="mt-1 shrink-0" />
          <p className="text-base sm:text-lg font-semibold leading-relaxed">{c.hero}</p>
        </div>

        <div>
          <h2 className="font-display text-xl sm:text-2xl font-bold text-slate-900">{c.howTo}</h2>
          <ol className="mt-5 space-y-4">
            {c.steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <li
                  key={i}
                  data-testid={`gratis-step-${i + 1}`}
                  className="flex gap-4 rounded-2xl border border-slate-100 bg-[#F8FAFC] px-4 py-4"
                >
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sky-600 font-mono text-sm font-bold text-white">
                    {i + 1}
                  </div>
                  <div className="space-y-3">
                    <p className="flex items-start gap-2 text-sm sm:text-base text-slate-800">
                      <Icon size={18} className="mt-0.5 shrink-0 text-sky-600" />
                      <span>{s.text}</span>
                    </p>
                    {s.contract && (
                      <p className="break-all rounded-xl border border-slate-200 bg-white px-3 py-2 font-mono text-sm font-semibold text-slate-900">
                        {CONTRACT}
                      </p>
                    )}
                    {s.mail && (
                      <a
                        href={`mailto:${s.mail}`}
                        data-testid="gratis-send-mail"
                        className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-sky-600"
                      >
                        <Mail size={16} />
                        {s.mail}
                      </a>
                    )}
                  </div>
                </li>
              );
            })}
          </ol>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 text-sm text-slate-700">
          <p className="font-semibold text-slate-900">{c.teamLabel}</p>
          <p>{c.teamName}</p>
        </div>

        <div className="rounded-2xl border border-sky-200 bg-sky-50 px-5 py-4">
          <p className="font-semibold text-slate-900">{c.supportTitle}</p>
          <p className="mt-1 text-sm text-slate-700">{c.supportText}</p>
          <a
            href="mailto:info@ustp.it"
            data-testid="gratis-support-mail"
            className="mt-2 inline-flex items-center gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-sky-500"
          >
            <Mail size={16} />
            info@ustp.it
          </a>
        </div>
      </div>
    </Layout>
  );
}
